export default __webpack_public_path__ + "static/media/Shot_25.0000.31eee53b.png";